module.exports = __webpack_public_path__ + "static/media/dadCo_v2.488713da.jpg";